import React from 'react';

import InputIcon, { IInputIcon, IInputIconWithType } from './InputIcon';

type IInputTrailingIcon = IInputIcon & IInputIconWithType;

const InputTrailingIcon: React.FC<IInputTrailingIcon> = ({ children, onClick, ...props }) => (
    <InputIcon {...props} onClick={onClick}>
        {children}
    </InputIcon>
);

InputTrailingIcon.defaultProps = {
    __TYPE: 'InputTrailingIcon'
};

export default InputTrailingIcon;
